import React from "react";
import { HiCheckBadge } from "react-icons/hi2";
import { LoyaltyBadgeType } from "../../utils/loyaltyBadgeUtils";

interface LoyaltyBadgeProps {
  badge: LoyaltyBadgeType;
  className?: string;
  size?: "sm" | "md" | "lg";
  animate?: boolean;
  textColor?: "white" | "gray";
}

const LoyaltyBadge: React.FC<LoyaltyBadgeProps> = ({
  badge,
  className = "",
  size = "md",
  animate = false,
  textColor = "white",
}) => {
  const sizeClasses = {
    sm: { container: "w-6 h-6", icon: "h-4 w-4", text: "text-[10px]" },
    md: { container: "w-8 h-8", icon: "h-6 w-6", text: "text-xs" },
    lg: { container: "w-10 h-10", icon: "h-8 w-8", text: "text-sm" },
  };

  const getBadgeStyles = () => {
    const animateClass = animate ? "animate-pulse" : "";
    return `inline-flex items-center justify-center rounded-full ${sizeClasses[size].container} bg-green-500 border-2 border-white shadow-lg ${animateClass}`;
  };

  return (
    <div className={`flex flex-col items-center gap-1 ${className}`}>
      <div
        className={getBadgeStyles()}
        title={badge.label}
        aria-label={badge.label}
      >
        <HiCheckBadge
          className={`${sizeClasses[size].icon} text-white drop-shadow-sm`}
        />
      </div>
      <span
        className={`${sizeClasses[size].text} font-semibold ${
          textColor === "white" ? "text-white/90" : "text-gray-600/90"
        } tracking-wide uppercase`}
      >
        Verified
      </span>
    </div>
  );
};

export default LoyaltyBadge;
